import { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react'

import { CryptoPaymentModalData } from './CryptoPaymentModalData'
import { useCryptoCurrencies, useGetLastPurchasedCryptoCurrency, useWithdrawalFormAPI } from './hooks'
import { config } from '../../Init/Init'

const CryptoPaymentModalDataContext = createContext()
CryptoPaymentModalDataContext.displayName = 'CryptoPaymentModalDataContext'

export const useCryptoPaymentDataModal = () => useContext(CryptoPaymentModalDataContext)

export const CryptoPaymentModalDataProvider = ({
  children,
  cryptoPaymentModalMode,
  isCryptoPaymentModalOpen,
  setCryptoPaymentModalMode,
  handleCloseCryptoPaymentModal: handleCloseCryptoPaymentModalFromProps
}) => {
  const [loading, setLoading] = useState(true)
  const withdrawalFormRef = useRef(null)

  const { cryptoCurrencies, isCryptoCurrenciesLoading, setSelectedCurrency, selectedCurrency } = useCryptoCurrencies(
    cryptoPaymentModalMode
  )

  // we need this check since XRP coin has extra info - destination tag
  const isXRPCryptoType = useMemo(() => selectedCurrency.currencyCode === 'XRP', [selectedCurrency.currencyCode])

  const {
    handleSubmit,
    withdrawalStep,
    setWithdrawalStep,
    withdrawalDraftData,
    withdrawalFormError,
    updateDraftWithdrawal,
    setWithdrawalFormError,
    withdrawalResponseData,
    setWithdrawalDraftData,
    resetWithdrawalResponseData
  } = useWithdrawalFormAPI({
    loading,
    setLoading,
    isXRPCryptoType,
    withdrawalFormRef
  })

  const {
    lastPurchasedCryptoCurrencyData,
    isGetLastPurchasedCryptoCurrencyLoading,
    isGetLastPurchasedCryptoCurrencyDone
  } = useGetLastPurchasedCryptoCurrency()

  const handleCloseCryptoPaymentModal = useCallback(() => {
    handleCloseCryptoPaymentModalFromProps()
    setWithdrawalFormError('')
  }, [handleCloseCryptoPaymentModalFromProps, setWithdrawalFormError])

  return (
    <CryptoPaymentModalDataContext.Provider
      value={{
        loading,
        setLoading,
        cryptoCurrencies,
        selectedCurrency,
        setSelectedCurrency,
        setWithdrawalFormError,
        cryptoPaymentModalMode,
        isCryptoPaymentModalOpen,
        setCryptoPaymentModalMode,
        isCryptoCurrenciesLoading,
        handleCloseCryptoPaymentModal,
        withdrawalFormRef,
        handleSubmit,
        withdrawalStep,
        setWithdrawalStep,
        withdrawalDraftData,
        withdrawalFormError,
        withdrawalResponseData,
        resetWithdrawalResponseData,
        updateDraftWithdrawal,
        setWithdrawalDraftData,
        isXRPCryptoType,
        lastPurchasedCryptoCurrencyData,
        isGetLastPurchasedCryptoCurrencyLoading,
        isGetLastPurchasedCryptoCurrencyDone
      }}
    >
      {children}
      {config.enableCryptoWallet && <CryptoPaymentModalData />}
    </CryptoPaymentModalDataContext.Provider>
  )
}
